import React from 'react';
import './OurCustomers.css';

import bankIcon from '../../assets/icons/bank.png';
import paymentIcon from '../../assets/icons/payment.png';
import mutualIcon from '../../assets/icons/mutual.png';

export const OurCustomers = () => {
  return (
    <div className="our-customers-container">
      <h2>Our Customers</h2>
      <div className="customer-box">
        <div className="customer-item">
          <div className='image-wrapper bank'>
              <img src={bankIcon} alt="Banks" className="customer_icon" />
          </div>
          <p className="customer-label over-image">Banks</p>
        </div>

        <div className="customer-item ">
            <div className='image-wrapper payment'>
                <img src={paymentIcon} alt="Payment Apps" className="customer_icon" />
            </div>
          <p className="customer-label over-image">Payment Apps</p>
        </div>

        <div className="customer-item">
          <div className="image-wrapper mutual">
              <img src={mutualIcon} alt="Mutual Funds" className="customer_icon" />
          </div>
          <p className="customer-label over-image">Mutual Funds</p>
        </div>


      </div>

      <p className="description">
        Louie Voice is a sector agnostic Voice Interface and can voice enable
        any iOS and Android app, or any Website in the World.
      </p>
    </div>
  );
};